import React from 'react';
import { ModusWcDropdownMenu } from '@trimble-oss/moduswebcomponents-react';
import { DaisySize, ModusSize, PopoverPlacement } from '@trimble-oss/moduswebcomponents';
import { ButtonVariant } from '../button/Button';
import './DropdownMenu.scss';

export type DropDownEvent = (event: CustomEvent<{ isVisible: boolean }>) => void;

// DropdownMenu only supports Modus button colors.
export type DropdownButtonColor = 'primary' | 'secondary' | 'tertiary' | 'warning' | 'danger';

export interface DropdownMenuProps extends React.ComponentProps<typeof ModusWcDropdownMenu> {
  /**
   * The aria-label for the dropdown button.
   */
  buttonAriaLabel?: string;
  /**
   * The color variant of the button.
   */
  buttonColor?: DropdownButtonColor;
  /**
   * The size of the button.
   */
  buttonSize?: DaisySize;
  /**
   * The variant of the button.
   */
  buttonVariant?: ButtonVariant;
  /**
   * Custom CSS class to apply to the host element.
   */
  customClass?: string;
  /**
   * If true, the button will be disabled.
   */
  disabled?: boolean;
  /**
   * Indicates that the menu should have a border.
   */
  menuBordered?: boolean;
  /**
   * Distance between the button and menu in pixels.
   */
  menuOffset?: number;
  /**
   * The placement of the menu relative to the button.
   */
  menuPlacement?: PopoverPlacement;
  /**
   * The size of the menu.
   */
  menuSize?: ModusSize;
  /**
   * Indicates that the menu is visible.
   */
  menuVisible: boolean;

  onMenuVisibilityChange: DropDownEvent;
}

// Wrapper component with all types added
export const DropdownMenu: React.FC<DropdownMenuProps> = ({ children, buttonColor, ...props }) => {
  // Map 'neutral' to 'secondary' for ModusWcDropdownMenu compatibility.
  // Note: ModusWcButton supports 'neutral', but ModusWcDropdownMenu doesn't yet.
  // This maintains consistency with our Button component's ButtonColor type.

  return <ModusWcDropdownMenu {...props}>{children}</ModusWcDropdownMenu>;
};
